import { File } from "../types";
import { getLastFileByCreatedAt } from "./getLastFileByCreatedAt";
import { is2DFile } from "./is2DFile";

export const getFirst2DFile = <T extends Pick<File, "url" | "name" | "createdAt">>(
  files: T[],
): T | null => {
  const files2D = files.filter((file) => is2DFile(file));

  return getLastFileByCreatedAt(files2D) ?? null;
};
